import React from 'react';

interface ExpertiseHeaderProps {
  title: string;
  subtitle: string;
}

const ExpertiseHeader: React.FC<ExpertiseHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="relative text-center">
      {/* Decorative line */}
      <div className="absolute left-1/2 -translate-x-1/2 top-0 w-24 h-1 bg-gradient-to-r from-blue-400 to-violet-400" />
      
      <h2 className="mt-8 text-4xl font-bold text-white mb-6">
        {title}
      </h2>
      
      <p className="text-xl text-blue-100 max-w-3xl mx-auto">
        {subtitle}
      </p>

      {/* Decorative elements */}
      <div className="absolute -right-4 -top-4 w-20 h-20">
        <div className="absolute right-0 top-0 w-2 h-2 bg-blue-400 rounded-full" />
        <div className="absolute right-4 top-4 w-1 h-1 bg-violet-400 rounded-full" />
        <div className="absolute right-8 top-2 w-1.5 h-1.5 bg-indigo-400 rounded-full" />
      </div>
    </div>
  );
};

export default ExpertiseHeader;